<template>
    <svg @click="$emit('click', $event)" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height"
         viewBox="0 0 15.82 19.478">
        <g id="bin_1_" data-name="bin (1)" transform="translate(0.003 0.002)">
            <path id="Path_69994" data-name="Path 69994"
                  d="M222.854,154.7a.456.456,0,0,0-.456.456v8.621a.456.456,0,1,0,.912,0v-8.621A.456.456,0,0,0,222.854,154.7Zm0,0"
                  transform="translate(-212.256 -147.647)" fill="#3266F5"/>
            <path id="Path_69995" data-name="Path 69995"
                  d="M104.854,154.7a.456.456,0,0,0-.456.456v8.621a.456.456,0,1,0,.912,0v-8.621A.456.456,0,0,0,104.854,154.7Zm0,0"
                  transform="translate(-99.639 -147.647)" fill="#3266F5"/>
            <path id="Path_69996" data-name="Path 69996"
                  d="M1.292,5.8V17.036a2.517,2.517,0,0,0,.669,1.736,2.246,2.246,0,0,0,1.63.7h8.631a2.246,2.246,0,0,0,1.63-.7,2.517,2.517,0,0,0,.669-1.736V5.8a1.743,1.743,0,0,0-.447-3.427H11.738V1.8A1.792,1.792,0,0,0,9.932,0H5.881A1.792,1.792,0,0,0,4.075,1.8v.57H1.739A1.743,1.743,0,0,0,1.292,5.8Zm10.93,12.767H3.591A1.445,1.445,0,0,1,2.2,17.036V5.837h11.4v11.2a1.445,1.445,0,0,1-1.387,1.528ZM4.987,1.8a.879.879,0,0,1,.894-.89H9.932a.879.879,0,0,1,.894.89v.57H4.987ZM1.739,3.283H14.074a.821.821,0,1,1,0,1.642H1.739a.821.821,0,0,1,0-1.642Zm0,0"
                  transform="translate(0 0)" fill="#3266F5"/>
            <path id="Path_69997" data-name="Path 69997"
                  d="M163.854,154.7a.456.456,0,0,0-.456.456v8.621a.456.456,0,1,0,.912,0v-8.621A.456.456,0,0,0,163.854,154.7Zm0,0"
                  transform="translate(-155.948 -147.647)" fill="#3266F5"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IBin",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
